var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('crud-level'),_c('bottom-action-container',[_c('btn-skip',{on:{"navClicked":_vm.continuee}}),_c('template',{slot:"end"},[_c('btn-grp',[_c('btn',{attrs:{"text":"Previous","type":"secondary"},on:{"click":_vm.previous}}),_c('btn',{attrs:{"text":"Next","type":"primary"},on:{"click":_vm.continuee}})],1)],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }